import PropTypes from "prop-types";
import { Button } from "../common";

export const Question7 = ({ updateQuestion }) => {
  return (
    <div className="question7">
      <h2 className="question7__title">
        Changes to the way we handle NHS complaints
      </h2>

      <p className="question7__text">
        We've made changes to the way we handle NHS complaints. This is to
        reduce wait times for people who bring their complaints to us and make
        sure we quickly identify significant service failings.
      </p>

      <p className="question7__text">
        We will only look further into the more serious complaints about the NHS
        that people bring to us.
      </p>

      <p className="question7__subtitle">
        Please do not submit a complaint to us if it is about:
      </p>

      <ul className="question7__list">
        <li>Delays with complaint responses</li>
        <li>
          Matters which are likely to resolve themselves within the next few
          weeks or months
        </li>
      </ul>

      <p className="question7__text">
        Find out more about{" "}
        <a
          href="https://www.ombudsman.org.uk/service-update"
          target="_blank"
          rel="noopener noreferrer"
        >
          changes to the way we handle NHS complaints.
        </a>
      </p>

      <div className="question7__actions">
        <Button variant="cancel" onClick={() => updateQuestion(6)}>
          Back
        </Button>
        <Button variant="continuation" onClick={() => updateQuestion(8)}>
          Continue complaint
        </Button>
      </div>
    </div>
  );
};

Question7.propTypes = {
  updateQuestion: PropTypes.func,
};
